import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>DentoXcellence</h3>
            <p>Leader de la formation dentaire en Algérie</p>
            <div className="footer-social">
              <a href="#" className="social-link"><i className="fab fa-facebook"></i></a>
              <a href="#" className="social-link"><i className="fab fa-instagram"></i></a>
              <a href="#" className="social-link"><i className="fab fa-linkedin"></i></a>
              <a href="https://wa.me/213797607481" className="social-link"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Formations</h4>
            <ul className="footer-links">
              <li><Link to="/formations#cone-beam">Cone Beam CBCT</Link></li>
              <li><Link to="/formations#chirurgie">Chirurgie Orale</Link></li>
              <li><Link to="/formations#prothese">Prothèse Conjointe</Link></li>
              <li><Link to="/formations#implantologie">Implantologie</Link></li>
              <li><Link to="/formations#esthetique">Esthétique du Sourire</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <div className="footer-contact">
              <p><i className="fas fa-map-marker-alt"></i> Annaba, Algérie</p>
              <p><i className="fas fa-phone"></i> +213 797 60 74 81</p>
              <p><i className="fas fa-envelope"></i> elitedentala@gmail.com</p>
              <p><i className="fas fa-clock"></i> Toujours disponible</p>
            </div>
          </div>
          <div className="footer-section">
            <h4>Liens Rapides</h4>
            <ul className="footer-links">
              <li><Link to="/about">À propos</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/formations">Formations</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 DentoXcellence. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

